
<template>
  <!--活动管理-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_url" slot-scope="{row}">
        <img style="height: 44px" :src="row.url" alt="">
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.status]"></span>
          <span>{{ row.statusDesc }}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
const activityType = [
  { value: 0, label: '已停止' },
  { value: 1, label: '进行中' },
  { value: 2, label: '已结束' },
  { value: 3, label: '未开始' }
];
export default {
  name: 'activityManage',
  data () {
    return {
      activityText: ['已结束', '进行中', '已停止', '未开始'],
      activityColor: [
        'danger-bg', // 已停止
        'success-bg', // 进行中
        'info-bg', // 已结束
        'info-bg' // 未开始
      ],
      searchList: [
        { props: ['title'], placeholder: '活动标题', options: [], inputType: 'input' },
        { props: ['createDate'], placeholder: ['活动时间', '活动时间'], options: [], inputType: 'datePick' },
        { props: ['status'], placeholder: '状态', options: activityType, inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '查看订单',
          handle: row => this.showOrder(row),
          permi: ['community:activityManage:show']
        },
        {
          text: '配置',
          handle: row => this.$refs.table.toEdit(row), // 进行中
          rowOptDisHandle: row => row.status === 2, // 已结束 0，不能配置
          permi: ['community:activityManage:edit']
        },
        {
          text: '',
          handle: row => this.changeStatus(row),
          rowOptDisHandle: row => [2, 3].some(item => item === row.status), // 已结束、未开始不能切换
          rowOptText: row => row.status === 1 ? '禁用' : '启用',
          customRender: true,
          permi: ['community:activityManage:status']
        }
      ],
      columns: [
        { title: '活动编号', dataIndex: 'id', align: '', width: '' },
        { title: '活动图片', dataIndex: 'url', align: '', width: '', scopedSlots: { customRender: 'url' } },
        { title: '活动标题', dataIndex: 'title', align: '', width: '' },
        { title: '活动时间', dataIndex: 'activityTime', align: '', width: '' },
        { title: '活动状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        createDate: undefined,
        status: undefined
      },
      listApi: {
        url: '/pm/lottery/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addActivity',
        addTitle: '新建活动',
        editTitle: '编辑活动'
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
  },
  methods: {
    getSelect () {
    },
    /** 查看订单 */
    showOrder (row) {
      this.$router.push({
        name: 'activityOrder',
        query: { id: row.id, activityTitle: row.title, time: row.activityTime }
      });
    },
    /** 切换状态 */
    changeStatus (row) {
      this.$put({
        url: `/pm/lottery/changeStatus/${row.id}`,
        params: { status: row.status === 1 ? 0 : 1 } // 0停用，1启用
      }).then(({ data }) => {
        this.$message.success('切换成功');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
